
export const changePage = (page) => {
    return {
        type: 'Spa_Page_Change',
        payload: page
    }
}

export const subMenuTitle = (title) => {
    return {
        type: 'Spa_Sub_Title_Change',
        payload: title
    }
}

export const selectedItem = (title) => {
    return {
        type: 'Spa_Item_Title_Change',
        payload: title
    }
}